import { useOutletContext } from "react-router";
import { omniOfferServiceKinds } from "@/services/backend/omni/servicekindrules/omni-offer-setup-dropdown-config";
import {
  GSMServiceKind,
  parseServiceKind,
} from "@/services/backend/services/types/kinds";

/**
 * omniBaseDataServiceKinds are the service kinds whose base data is edited
 * in the omni base data routes: every kind an omni document may have.
 */
export const omniBaseDataServiceKinds: GSMServiceKind[] = omniOfferServiceKinds;

/**
 * parseOmniBaseDataServiceKind returns the service kind of the route
 * parameter param, or undefined if it is none of the
 * {@link omniBaseDataServiceKinds}.
 */
export function parseOmniBaseDataServiceKind(
  param: string | undefined,
): GSMServiceKind | undefined {
  const kind = parseServiceKind(param ?? "");

  return kind && omniBaseDataServiceKinds.includes(kind) ? kind : undefined;
}

/**
 * useOmniBaseDataServiceKind returns the service kind the
 * OmniBaseDataRoute renders its pages for.
 */
export function useOmniBaseDataServiceKind(): GSMServiceKind {
  return useOutletContext<GSMServiceKind>();
}
